import {SagaIterator} from 'redux-saga';
import {call} from 'redux-saga/effects';
import {instanceGusaBackend} from 'libs/api';
import {ENDPOINTS} from 'constants/endpoints';
import {logWithSentry} from 'libs/sentry/sentry';

/**
 * Get data for a last order
 * @return {LastOrderType} last order data
 */
export function* getLastOrderData(): SagaIterator {
    try {
        const {data} = yield call(instanceGusaBackend.get, ENDPOINTS.SUCCESS_PAYMENTS);
        return data;
    } catch (error) {
        yield call(logWithSentry, error, '"orderLast" TYP request failed');
        return {};
    }
}
